import React from "react";
import "./Projects.scss";

const projectsData = [
  {
    title: "Canceles",
    category: "Residencial",
     image: "/images/canceles.jpg",
  },
  {
    title: "Barandales de vidrio",
    category: "Residencial",
    image: "/images/barandales.jpg",
  },
  {
    title: "Divisiones para oficina",
    category: "Comercial",
    image: "/images/oficinas.jpg",
  },
  {
    title: "Puertas y ventanas de aluminio",
    category: "Residencial",
    image: "/images/puertas.jpg",
  },
  {
    title: "Fachadas y cerramientos",
    category: "Comercial",
    image: "/images/fachadas.jpg",
  },
  {
    title: "Proyectos especiales",
    category: "Residencial / Comercial",
    image: "/images/proyectos.jpg",
  },
];

const Projects = () => {
  return (
    <section className="projects" id="proyectos">
      <div className="projects__container">
        <div className="projects__top">
          <span className="projects__eyebrow">Proyectos</span>

          <div className="projects__heading">
            <h2 className="projects__title">
              Trabajos que reflejan calidad, diseño y atención al detalle
            </h2>
          </div>
        </div>

        <div className="projects__grid">
          {projectsData.map((project, index) => (
            <article className="projects__card" key={index}>
              <div className="projects__image-wrapper">
                <img
                  src={project.image}
                  alt={project.title}
                  className="projects__image"
                />
                <div className="projects__overlay">
                  <span className="projects__category">{project.category}</span>
                  <h3 className="projects__card-title">{project.title}</h3>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;